export default "__VITE_ASSET__DJaZu214__"